import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function createWorkbook(name: string, year: number, isPrimary: boolean): Promise<void> {
    if (api.clientApi) {
        await api.clientApi.clientWorkbookCreate(store.db ? store.db : "", name, year, isPrimary).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
        });
    }
}

export { createWorkbook };
